export class JsonObject{

	data:any

	constructor(jsonData:any){
		this.data = jsonData
	}

	toModel<T>(classInstanceT){

	}

}
